import { render, staticRenderFns } from "./SystemPage.vue?vue&type=template&id=2a9e570f&scoped=true&"
import script from "./SystemPage.vue?vue&type=script&lang=js&"
export * from "./SystemPage.vue?vue&type=script&lang=js&"
import style0 from "./SystemPage.vue?vue&type=style&index=0&id=2a9e570f&prod&scoped=true&TableListComponent=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e570f",
  null
  
)

export default component.exports